"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _Tooltip = _interopRequireDefault(require("@cimpress/react-components/lib/Tooltip"));

var _emotion = require("emotion");

var _Price = _interopRequireDefault(require("./Price"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  height: 32px;\n  width: 120px;\n  display: table-caption;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var errorStyle = (0, _emotion.css)(_templateObject());
var colorStyle = {
  Error: colors.danger.base,
  Warning: colors.warning.base,
  Info: colors.info.darker
};

var ErrorTable =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ErrorTable, _Component);

  function ErrorTable() {
    (0, _classCallCheck2.default)(this, ErrorTable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ErrorTable).apply(this, arguments));
  }

  (0, _createClass2.default)(ErrorTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          quantities = _this$props.quantities,
          width = _this$props.width;
      return _react.default.createElement("table", {
        className: "table table-striped pricing-table",
        style: {
          width: width
        }
      }, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
        className: "pricing-cell header list-price"
      }, _react.default.createElement(_Tooltip.default, {
        direction: "top",
        contents: error.detailedMessage
      }, _react.default.createElement("div", {
        className: "custom-select ".concat(errorStyle)
      }, _react.default.createElement(_reactComponents.Icon, {
        color: colorStyle[error.type],
        name: "report-problem-triangle-f",
        size: "2x"
      }), _react.default.createElement("div", null, error.shortMessage)))))), _react.default.createElement("tbody", null, quantities.map(function (qty) {
        return _react.default.createElement("tr", {
          key: qty,
          className: "pricing-row"
        }, _react.default.createElement(_Price.default, {
          key: "".concat(qty),
          priceMode: "total"
        }));
      })));
    }
  }]);
  return ErrorTable;
}(_react.Component);

exports.default = ErrorTable;
ErrorTable.defaultProps = {
  width: '170px'
};